import { DateUtil } from '@utils/dateUtil'
import { Weekdays } from '@utils/weekdays'

export enum ActionsT {
  UPDATE_BOOKING_DATE,
  CLEAR_BOOKING_DATE,
  UPDATE_RECURRED_BOOKING,
  CLEAR_RECURRED_BOOKING,
  SET_BOOK_DESK,
  SELECT_SPACE,
}

export enum TypePattern {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  NEVER = 'never',
}

export enum RangePattern {
  ON_DATE = 'end_date',
  AFTER = 'numbered',
}

export const RangePatternT = {
  ON_DATE: { value: 'end_date', text: 'On date' },
  AFTER: { value: 'numbered', text: 'After' },
}

export type RecurrenceT = {
  typePattern: TypePattern
  rangePattern: RangePattern
  typeInterval: number
  rangeInterval: number
  rangeDate: DateUtil
  daysOfWeek: Weekdays[]
  monthlyType: string
  numberLimit: number
  dateLimit: DateUtil
  weekdays: Weekdays[]
  userSelectedRangeDate: boolean
}

export type BookingDate = {
  fromDate: DateUtil
  toDate: DateUtil | null
}

export type StateT = {
  date: BookingDate
  recurrence: RecurrenceT
}

export type BookDeskParamT = {
  spaceId: string
  employeeId: string
  note?: string
  startDate: DateUtil
  endDate: DateUtil
  timezone?: string
}

export type BookDeskT = { bookDesk: boolean; bookRoom: boolean; spaceId: string }

export type StoreT = StateT & {
  updateBookingDate: (date: Partial<BookingDate>) => void
  clearBookingDate: () => void
  updateRecurredBooking: (recurrence: Partial<RecurrenceT>) => void
  clearRecurredBooking: () => void
}

export type UpdateBookingDate = {
  type: ActionsT.UPDATE_BOOKING_DATE
  date: Partial<BookingDate>
}
export type ClearBookingDate = {
  type: ActionsT.CLEAR_BOOKING_DATE
}

export type UpdateRecurredBooking = {
  type: ActionsT.UPDATE_RECURRED_BOOKING
  recurrence: Partial<RecurrenceT>
}

export type ClearRecurredBooking = {
  type: ActionsT.CLEAR_RECURRED_BOOKING
}

export type ActionsTypesT =
  | UpdateBookingDate
  | ClearBookingDate
  | UpdateRecurredBooking
  | ClearRecurredBooking
